import { isValidCpf } from '@brazilian-utils/is-valid-cpf';
import FormField from '@components/atoms/FormField';
import GridBox from '@components/atoms/GridBox';
import TextField from '@components/atoms/TextField';
import BotExplanation from '@components/molecules/BotExplanation';
import OnboardingButtonBar from '@components/molecules/button-bar/OnboardingButtonBar';
import { usePersonQuery } from '@graphql/generated';
import { CpfFormResult, QuoteInitialForm } from '@lib/data/typesQuestions';
import React, { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';

const CPFForm = ({
  onSubmit,
  loading,
  item,
  hideBotExplanation,
}: {
  onSubmit: (data: CpfFormResult) => void;
  loading: boolean;
  item: QuoteInitialForm;
  hideBotExplanation?: boolean;
}) => {
  const { register, handleSubmit, errors } = useForm<{ cpf: string }>();

  const [CPF, setCPF] = useState('');

  const [{ data, fetching }] = usePersonQuery({
    variables: {
      cpf: CPF,
    },
    pause: !CPF,
  });

  useEffect(() => {
    if (data)
      onSubmit(
        data.person ? { conductor: data.person } : { conductor: { cpf: CPF } },
      );
  }, [data, onSubmit, CPF]);

  return (
    <form onSubmit={handleSubmit(({ cpf }) => setCPF(cpf))}>
      <GridBox justifyContent="center">
        <GridBox width={[1, 0.5, 0.5]}>
          <FormField style={{ width: '100%' }}>
            <TextField
              name="cpf"
              defaultValue={item.conductor?.cpf || ''}
              placeholder="000.000.000-00"
              inputRef={register({
                required: 'Precisamos de um CPF válido',
                validate: {
                  valid: (s) => isValidCpf(s) || 'Precisamos de um CPF válido',
                },
              })}
              type="tel"
              errorMessage={errors?.cpf?.message}
              mask={[
                /\d/,
                /\d/,
                /\d/,
                '.',
                /\d/,
                /\d/,
                /\d/,
                '.',
                /\d/,
                /\d/,
                /\d/,
                '-',
                /\d/,
                /\d/,
              ]}
            />
          </FormField>
        </GridBox>
      </GridBox>

      {!hideBotExplanation && (
        <BotExplanation>
          O CPF é usado para calcular o preço do seu seguro. Fique tranquilo,
          seus dados estão protegidos{' '}
          <span role="img" aria-labelledby="cadeado">
            🔒
          </span>
        </BotExplanation>
      )}
      <OnboardingButtonBar loading={loading || fetching} />
    </form>
  );
};

export default CPFForm;
